import React from 'react';
import { Colors, Flex, IconGift, Typography } from '@banhala/ui-kit';

export const GiftButton: React.FC<{ onPress: () => void }> = props => {
  return (
    <Flex
      gap={2}
      alignItems={'center'}
      padding={{ horizontal: 12 }}
      onPress={props.onPress}
      testID={`선물하기버튼`}
    >
      <IconGift size={24} fill={Colors.content_primary} />
      <Typography type={'body4'}>선물하기</Typography>
    </Flex>
  );
};
